module.exports = __webpack_public_path__ + "img/Obstwanderung.b7fdc4ce.svg";